export const MainCanvasNavbar = {
  MainNav: {
    flow: 'x',
    align: 'center',
    gap: 'X',
    LogoDropdown: {},
    TextNavbar: {}
  },
  ModesInNavbar: {
    margin: '- -Z'
  },
  CanvasPagesDropdown: {
    margin: '- -Z'
  },
  CanvasSearch: {
    flex: 1
  },
  History: {
    extends: 'NavbarButtonSet',
    gap: 'X2',
    margin: '- -Z - -Y2',
    Undo: {
      title: (el) => el.call('polyglot', 'editor.ext.undo'),
      icon: 'undo',
      onClick: (ev, el, s) => {
        el.sdk.undo()
      }
    },
    Redo: {
      title: (el) => el.call('polyglot', 'editor.ext.redo'),
      icon: 'redo',
      onClick: (ev, el, s) => {
        el.sdk.redo()
      }
    },
    History: {
      title: (el) => el.call('polyglot', 'editor.ext.history'),
      icon: 'sf history',
      onClick: (ev, el, s) => {
        el.getRootState().toggle('isVersionsOpen', {
          preventUpdate: true
        })
        el.getVersionsAside()?.update()
      }
    }
  },
  EnvsNavbar: {},
  PublishNavbar: {},
  MembersNavbar: {
    margin: '- -Z2 - -'
  },
  SharingNavbar: {},
  extends: 'Navbar',
  gap: 'A2',
  round: 'radiusPill',
  padding: 'V Z',
  userSelect: 'none',
  theme: 'common-box',
  // Card-outline-as-chrome on top of an already-filled surface
  // (design-direction.md §8). This is a floating pill toolbar over live
  // canvas content (§7.8 Toolbar island presentation) — the prescribed
  // separation for that is elevation, not a stroke (DESIGN_LANGUAGE §2.3).
  shadow: 'float'
}
